import React, {Component} from 'react';
import v from 'voca';
import {inject, observer} from "mobx-react";
import {UploadImageModal, UploadVideoModal, UploadDocumentModal} from "common-import/custom";
import {Request, VarHelper} from "common-import/helpers";
import moment from "moment";

const propertyProject = [
  "name",
  "description",
  "address",
  "country",
  "city",
  "district",
  "investmentType",
  "budget",
  "constructionArea",
  "landArea",
  "minStartTime",
  "maxStartTime",
  "minFinishTime",
  "maxFinishTime",
  "projectSubType",
  "projectType",
  "purpose",
  "state",
  "status"
];

let initialData = {};
propertyProject.forEach(item => { initialData[item] = '' });

@inject("projectStore", "masterStore", "participantStore", "contactStore", "biddingCategoryStore", "contractorStore", "companyInfoStore") @observer
class ImportProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: initialData,
      multiProject: [],
      participants: [],
      biddingScopes: [],
      messages: [],
      file: null,
      openVideoModal: false,
      openImageModal: false,
      openDocumentModal: false,
      isSaving: false,
      isMultipleImport: false,
      isUploading: false,
      isSpecific: {
        budget: true,
        landArea: true,
        constructionArea: true
      },
    };
  }

  renderForm = () => {
    const {
      toValue,
      toSelectData,
      project_type,
      project_sub_type,
      project_work_type,
      project_state_status,
      project_state,
      project_status,
      project_investment_type,
      project_investment_type_app,
      project_purpose,
      project_budget,
      project_construction_area,
      project_land_area,
      country, city, district
    } = this.props.masterStore;

    const propMaster = {
      projectType: project_type,
      projectSubType: project_sub_type,
      workType: project_work_type,
      investmentType: project_investment_type_app,
      purpose: project_purpose,
      status: project_state_status,
      state: project_state,
      country: country,
      district: district,
      city: city,
      budget: project_budget,
      landArea: project_land_area,
      constructionArea: project_construction_area
    };

    const renderOptions = (prop) => {
      const arr = [{id: 'null', label: '', value: 'null'}, ...toSelectData(propMaster[prop])];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    const handleSpecialField = (property) => {
      let defaultValue = '';
      let firstFieldName, secondFieldName;
      if (property === "budget") {
        firstFieldName = "minBudget";
        secondFieldName = "maxBudget";
        defaultValue = this.state.current.minBudget + '-' + this.state.current.maxBudget
      } else if (property === "landArea") {
        firstFieldName = "minLandArea";
        secondFieldName = "maxLandArea";
        defaultValue = this.state.current.minLandArea + '-' + this.state.current.maxLandArea
      } else if (property === "constructionArea") {
        firstFieldName = "minConstructionArea";
        secondFieldName = "maxConstructionArea";
        defaultValue = this.state.current.minConstructionArea + '-' + this.state.current.maxConstructionArea
      } else {
        defaultValue = this.state.current[property]
      }
      return <div className="position-relative form-group">
        <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
        <select
          id={"nf-" + property}
          name={"nf-" + property}
          className="form-control"
          defaultValue={defaultValue}
          onChange={e => {
            if (toValue(propMaster[property], e.target.value).includes("___")) {
              this.setState({isSpecific: {...this.state.isSpecific, [property]: true}})
            } else {
              this.setState({
                isSpecific: {...this.state.isSpecific, [property]: false},
              });
              if (property === "purpose") {
                this.setState({
                  current: { ...this.state.current, [property]: e.target.value }
                })
              } else {
                this.setState({
                  current: { ...this.state.current, ...VarHelper.getSpecificMinMax(toValue(propMaster[property], e.target.value), firstFieldName, secondFieldName) }
                })
              }
            }
          }}
        >
          {renderOptions(property)}
        </select>
        {this.state.isSpecific[property] ?
          <input type="text"
                 className="form-control"
                 id={"nfi-" + property}
                 name={"nfi-" + property}
                 defaultValue={defaultValue}
                 onChange={e => {
                   if (property === "purpose") {
                     this.setState({
                       current: { ...this.state.current, [property]: e.target.value }
                     })
                   } else if (!!VarHelper.getSpecificMinMax(e.target.value, firstFieldName, secondFieldName)) {
                     this.setState({
                       current: { ...this.state.current, ...VarHelper.getSpecificMinMax(e.target.value, firstFieldName, secondFieldName) }
                     })
                   }
                 }}
          />
          : ''
        }
      </div>
    };

    return (
      <form className="form">
        <div className="row">
          {
            propertyProject.map((property, index) => {
              let element;
              if (property === 'description') {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <textarea
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    value={this.state.current[property] || ''}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else if (["projectType", "projectSubType", "workType", "investmentType", "country", "state", "status"].includes(property)) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <select
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  >
                    {renderOptions(property)}
                  </select>
                </div>
              } else if (["budget", "landArea", "constructionArea", "purpose"].includes(property)) {
                // ====== ABC xyz ======== //
                element = handleSpecialField(property)
              } else if (["minStartTime", "maxStartTime", "minFinishTime", "maxFinishTime"].includes(property)) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)} <span className="small text-muted">format(YYYY-MM-DD)</span></label>
                  <input
                    type="text"
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    value={moment(this.state.current[property]).format('YYYY-MM-DD')}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <input
                    type="text"
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    value={this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              }

              return (
                <div className="col-md-6" key={"property" + index}>
                  {element}
                </div>
              );
            })
          }
        </div>
      </form>
    )
  };

  handleCloseModal = () => {
    this.setState({
      openVideoModal: false,
      openImageModal: false,
    });
  };

  handleOpenModal = (type) => {
    this.setState({
      openVideoModal: type === 'video',
      openImageModal: type === 'image',
      openDocumentModal: type === 'document',
    });
  };

  handleSubmitModal = async (list) => {
    const { current, openImageModal, openVideoModal, openDocumentModal } = this.state;

    if (openVideoModal) {
      this.setState({ project: {...current, listVideos: [...list]} });
    } else if (openImageModal) {
      this.setState({ project: {...current, listImages: [...list]} });
    } else if (openDocumentModal) {
      this.setState({ project: {...current, documents: [...list]} });
    }

    this.setState({
      openImageModal: false,
      openVideoModal: false,
      openDocumentModal: false,
    });
  };

  renderSingleImport = () => {
    const { current } = this.state;
    return (
      <div className="row">
        <div className="col-md-7">
          <div className="card">
            <div className="card-body">
              {this.renderForm()}
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-picture-o"> </i> Images</span>
            </div>
            <div className="card-body">
              <div className="input-group">
                <input type="text" disabled={true} className="form-control"
                       value={!!current.listImages ? current.listImages.join(', ') : ''}
                />
                <div className="input-group-append">
                  <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('image')}>Upload</button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-video-camera"> </i> Videos</span>
            </div>
            <div className="card-body">
              <div className="input-group">
                <input type="text" disabled={true} className="form-control"
                       value={!!current.listVideos ? current.listVideos.join(', ') : ''}
                />
                <div className="input-group-append">
                  <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('video')}>Upload</button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-envelope"> </i> Documents</span>
            </div>
            <div className="card-body">
              <div className="input-group">
                <input type="text" disabled={true} className="form-control"
                       value={!!current.documents ? current.documents.map(item => item.url).join(', ') : ''}
                />
                <div className="input-group-append">
                  <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('document')}>Upload</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  uploadXLSX = (e) => {
    !!e && e.preventDefault();
    this.setState({
      isUploading: true,
      file: e.target.files[0]
    });
    VarHelper.readXLSX(e, (data) => {
      const contacts = VarHelper.formatDataXLSX(data['contacts']);
      const materials = VarHelper.formatDataXLSX(data['materials']);
      const works = VarHelper.formatDataXLSX(data['works']);
      const multiProject = VarHelper.formatDataXLSX(data['Project']);
      let participants = VarHelper.formatDataXLSX(data['Participant']);
      participants = this.syncData(participants, 'contacts', contacts);
      let biddingScopes = VarHelper.formatDataXLSX(data['Bidding Scope']);
      biddingScopes = this.syncData(biddingScopes, 'works', works);
      biddingScopes = this.syncData(biddingScopes, 'materials', materials);

      this.setState({
        isUploading: false,
        multiProject,
        participants,
        biddingScopes
      });
    }, ['Project', 'Participant', 'Bidding Scope', 'works', 'materials', 'contacts']);
  };

  /*
    * @param original
    * @param field // field name: works, materials...
    * @param data
  * */
  syncData = (original = [], field, data = []) => {
    return original.map((item) => {
      const filterData = data.filter((itm) => {
        if (field === "contacts") {
          if (item.STT == itm.STTPA) return itm;
        } else if (item.STT == itm.STTBS) return itm;
      });
      return {...item, [field]: filterData};
    });
  };

  formatFieldFromExcel = async (obj, type) => {
    const {
      findID,
      project_type,
      project_sub_type,
      project_investment_type_app,
      project_budget,
      project_work_type,
      project_land_area,
      project_state,
      project_state_status,
      project_status,
      project_purpose,
      project_company_role,
      country, city, district,
      project_bidding_scope_name,
      contractor_type,
    } = this.props.masterStore;
    const propMaster = {
      project: {
        projectType: project_type,
        projectSubType: project_sub_type,
        workType: project_work_type,
        investmentType: project_investment_type_app,
        purpose: project_purpose,
        status: project_state_status,
        state: project_state,
        stage: project_state_status,
        country,
        district,
        city
      },
      biddingScope: {
        name: project_bidding_scope_name,
        expectTypeOfContractor: contractor_type,
        expectCountryOfContractor: country,
        expectCityOfContractor: city,
        expectDistrictOfContractor: district,
      },
      participant: {
        role: project_company_role,
      }
    };
    const needToConvert = {
      project: ["projectType", "projectSubType", "workType", "investmentType", "purpose", "status", "state", "stage", "country", "city", "district"],
      biddingScope: ["name", "expectTypeOfContractor", "expectCountryOfContractor", "expectCityOfContractor", "expectDistrictOfContractor"],
      participant: ["role"],
    };
    let newObj = {};
    for (let key in obj) {
      if (needToConvert[type].indexOf(key) !== -1) {
        newObj[key] = findID(propMaster[type][key], obj[key]);
        if (newObj[key] === -1) {
          newObj[key] = obj[key];
        }
      } else if (["listImages", "listVideos"].indexOf(key) !== -1) {
        newObj[key] = obj[key].split(",");
      } else if (key === "documents") {
        const arr = obj[key].split(",");
        newObj[key] = arr.map((item, index) => {
          return { id: index, url: item };
        });
      } else if (key === "address") {
        newObj[key] = obj[key];
        newObj["location"] = await VarHelper.getLatLngFromAddress(obj[key]);
      } else if (key === "constructionArea") {
        newObj["minConstructionArea"] = VarHelper.getNumber(obj[key].split('-')[0]);
        newObj["maxConstructionArea"] = VarHelper.getNumber(obj[key].split('-')[1]);
      } else if (key === "budget") {
        newObj["minBudget"] = VarHelper.getNumber(obj[key].split('-')[0]);
        newObj["maxBudget"] = VarHelper.getNumber(obj[key].split('-')[1]);
      } else if (key === "landArea") {
        newObj["minLandArea"] = VarHelper.getNumber(obj[key].split('-')[0]);
        newObj["maxLandArea"] = VarHelper.getNumber(obj[key].split('-')[1]);
      } else {
        newObj[key] = obj[key];
      }
    }
    if (type === 'project') newObj.totalFloorArea = newObj.maxLandArea + newObj.maxConstructionArea;
    return newObj;
  };

  addMultiple = async () => {
    const { projectStore, participantStore, biddingCategoryStore } = this.props;
    let { multiProject, biddingScopes, participants } = this.state;
    if (!multiProject.length) return null;
    this.setState({ isSaving: true });
    for (let i = 0; i < multiProject.length; i++) {
      let msg = {create: {}, approve: {}, participant: [], bidding: {create: [], approve: []}};
      const dataProject = await this.formatFieldFromExcel(multiProject[i], 'project');
      const payloadProject = this.formatPayload(dataProject);
      const resProject = await projectStore.create(payloadProject);

      if (!!resProject.error) {
        msg = {...msg, create: {success: false, msg: `(STT ${multiProject[i].STT}) ${multiProject[i].name}: ${resProject.error}`}};
      } else {
        msg = {...msg, create: {success: true, msg: `(STT ${multiProject[i].STT}) ${multiProject[i].name}`}};
        const resApprove = await projectStore.approve({ id: resProject.data.id, approved: multiProject[i].approve.toLowerCase() === "yes" });
        if (!!resApprove.error) {
          msg = {...msg, approve: {success: false, msg: `(STT ${multiProject[i].STT}) ${multiProject[i].name}: ${resApprove.error}`}}
        } else {
          msg = {...msg, approve: {success: true, msg: `(STT ${multiProject[i].STT}) ${multiProject[i].name}`}}
        }
      }

      const parts = participants.filter(item => item.STTP == multiProject[i].STT);
      let msgParticipant = [];
      for (let j = 0; j < parts.length; j++) {
        if (!!resProject.error) break;
        const contractor = await this.getContractorDetail(parts[j]);
        if (!contractor && !contractor.companyTaxCode) {
          continue;
        }
        const contacts = await this.getContactDetail(parts[j].contacts, contractor.companyTaxCode);
        parts[j] = {...parts[j], ...contractor, contacts, projectId: resProject.data.id};
        const dataParticipant = await this.formatFieldFromExcel(parts[j], 'participant');
        const payloadParticipant = this.formatPayload(dataParticipant, 'participant');
        const resParticipant = await participantStore.create(payloadParticipant);
        if (!!resParticipant.error) {
          msgParticipant = [...msgParticipant, {success: false, msg: `(STT ${parts[j].STT}) ${resParticipant.error}`}];
        } else {
          msgParticipant = [...msgParticipant, {success: true, msg: `(STT ${parts[j].STT}) ${parts[j].name}`}];
        }
        msg = {...msg, participant: msgParticipant};
      }

      const bidding = biddingScopes.filter(item => item.STTP == multiProject[i].STT);
      let msgBidding = {create: [], approve: []};
      for (let k = 0; k < bidding.length; k++) {
        if (!!resProject.error) break;
        const dataBidding = await this.formatFieldFromExcel(bidding[k], 'biddingScope');
        const payloadBidding = this.formatPayload(dataBidding, 'biddingScope');
        const resBidding = await biddingCategoryStore.create({...payloadBidding, projectId: resProject.data.id});
        if (!!resBidding.error) {
          msgBidding.create = [...msgBidding.create, {success: false, msg: `(STT ${bidding[k].STT}) ${resBidding.error}`}];
          msg = {...msg, bidding: msgBidding};
          continue;
        }
        msgBidding.create = [...msgBidding.create, {success: true, msg: `(STT ${bidding[k].STT}) ${bidding[k].name}`}];
        msg = {...msg, bidding: msgBidding};
        const resApprove = await biddingCategoryStore.approve({ id: resBidding.data.id, approved: bidding[k].approve.toLowerCase() === "yes" });
        if (!!resApprove.error) {
          msgBidding.approve = [...msgBidding.approve, {success: false, msg: `(STT ${bidding[k].STT}) ${resApprove.error}`}];
        } else {
          msgBidding.approve = [...msgBidding.approve, {success: true, msg: `(STT ${bidding[k].STT}) ${bidding[k].name}`}];
        }
        msg = {...msg, bidding: msgBidding};
      }

      this.setState({ messages: [...this.state.messages, msg] });
    }
    window.toast.info('Finish.');
    this.setState({ isSaving: false, file: null });
  };

  getContractorDetail = async ({participantId}) => {
    const { contractorStore } = this.props;
    const res = await contractorStore.detail(participantId);
    if (!res.error) {
      return { name: res.data.name, companyTaxCode: res.data.taxCode }
    }
    return null;
  };

  getContactDetail = async (list, companyTaxCode) => {
    const { contactStore } = this.props;
    let newList = [];
    for (let i = 0; i < list.length; i++) {
      const res = await contactStore.getContactList(companyTaxCode);
      if (!!res.data) {
        const contact = res.data.filter(item => item.id == list[i].id)[0] || {};
        newList = [...newList, contact];
      }
    }
    return newList;
  };

  renderMultipleImport = () => {
    const { file, isSaving, isUploading, multiProject, messages } = this.state;

    const showUploadStatus = () => {
      if (!isSaving && !multiProject.length) return (<h6>{isUploading ? 'Uploading...' : ''}</h6>);

      const renderStatus = (item) => {
        return <div style={{margin: '8px',fontSize: '12px'}} className="block-content">
          <p className={!!item.create.success ? 'text-success': 'text-danger'}>Created: {item.create.msg}</p>
          <p className={!!item.approve.success ? 'text-success': 'text-danger'}>Approved: {item.approve.msg}</p>
          <p>participant: </p>
          <ul>
            {item.participant.map((item, index) => <p className={!!item.success?'text-success':'text-danger'} key={'part'+index}>Added: {item.msg}</p>)}
          </ul>
          <p>bidding scope: </p>
          <ul>
            {item.bidding.create.map((item, index) => <p className={!!item.success?'text-success':'text-danger'} key={'part'+index}>Created: {item.msg}</p>)}
            {item.bidding.approve.map((item, index) => <p className={!!item.success?'text-success':'text-danger'} key={'part'+index}>Approved: {item.msg}</p>)}
          </ul>
        </div>
      };
      const blockStyle = {
        maxHeight: '512px',
        overflowY: 'auto',
        marginTop: '24px',
      };
      return (
        <div className="card">
          <div className="card-body">
            <h6 style={{marginBottom: '16px', display: !!file ? 'block': 'none'}}>
              {multiProject.length} projects will be added.
            </h6>
            <div style={blockStyle}>
              <div className="">
                {messages.map((item, index) => <div key={'block'+index}>{renderStatus(item)}</div>)}
              </div>
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="multiple-import">
        <div className="row">
          <div className="col-md-6">
            <div style={{marginBottom: '16px'}}>
              <a target="_blank" href="https://drive.google.com/drive/folders/1YjwJTADWCYt3C5RoS-G0JOmFeDHT28AG?usp=drive_open">
                Sample data here
              </a>
            </div>
            <div className="input-group">
              <input value={!!file ? file.name : ''} type="text" disabled={true} className="form-control" placeholder="*.xls / *.xlsx"/>
              <div className="input-group-append">
                <div style={{marginBottom: 0}} className="form-group group-file-upload">
                  <input onChange={e => this.uploadXLSX(e)} type="file" id="upload-files" name="upload-files" multiple={true} style={{display: "none"}}/>
                  <label className="btn btn-danger" htmlFor="upload-files"><i className="fa fa-envelope"> </i> Upload file</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{marginTop: '24px'}}>
          {/*{showUploadStatus()}*/}
        </div>
      </div>
    )
  };

  formatPayload = (data, type = 'project') => {
    let copy;

    let typeFormat = {
      typeDate: ["minStartTime", "maxStartTime", "minFinishTime", "maxFinishTime"],
      typeObject: ["location"],
      typeNumber: ["minBudget", "maxBudget", "minConstructionArea", "maxConstructionArea", "minLandArea", "maxLandArea", "totalFloorArea"],
      typeArray: ["documents", "listVideos", "listImages"],
      typeString: ["name", "description", "projectType", "projectSubType", "workType", "address", "village", "district", "city", "country", "investmentType", "state", "status", "purpose"],
    };
    if (type === 'biddingScope') {
      typeFormat = {
        typeDate: ["bidOpenTime", "bidCloseTime"],
        typeBoolean: ["allowAlternativeBids", "allowSealedBids"],
        typeArray: ["documents", "invitedEmails", "materials", "works"],
        typeNumber: ["expectExperienceContractor", "expectRatingOfContractor", "expectRevenueOfContractor"],
        typeString: ["name", "typeOfBid", "expectTypeOfContractor", "expectCountryOfContractor", "expectCityOfContractor", "expectDistrictOfContractor", "expectUnitRevenueOfContractor", "expectOtherRequirements", "preferredCurrency", "projectId"],
      };
    }
    if (type === 'participant') {
      typeFormat = {
        typeArray: ["contacts"],
        typeString: ["name", "participantType", "participantId", "projectId", "role"],
      };
    }

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  addSingle = async () => {
    const { projectStore } = this.props;
    const { current } = this.state;

    this.setState({ isSaving: true });
    const payload = this.formatPayload(current);
    const res = await projectStore.create(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error('Created failure: ' + JSON.stringify(res.error));
    }

    this.setState({
      current: {},
    });

    return window.toast.info('Created successfully.');
  };

  handleAdd = async () => {
    const { isMultipleImport } = this.state;
    if (!isMultipleImport) {
      await this.addSingle();
    } else {
      await this.addMultiple();
    }
  };

  clearData = (e) => {
    e.preventDefault();
    const { isMultipleImport } = this.state;
    if (window.confirm('Are you sure want to clear all inputs?')) {
      if (!isMultipleImport) {
        this.setState({ current: {} });
      } else {
        this.setState({ multiProject: [], file: null, messages: [] });
      }
      this.setState({ isUploading: false, isSaving: false });
    }
  };

  render() {
    const { current, isSaving, openVideoModal, openImageModal, openDocumentModal, isMultipleImport } = this.state;

    return (
      <div id="import-project-page" className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
              <i className="fa fa-envelope-open"> </i> Create new project
            </div>
            <div className="card-header-right">
              <button className="btn btn-sm btn-primary"
                      onClick={() => this.setState({ isMultipleImport: !isMultipleImport })}>
                Switch to {isMultipleImport ? 'Single Import' : 'Multiple Import'}
              </button>
            </div>
          </div>
          <div className="card-body">
            {isMultipleImport ? this.renderMultipleImport() : this.renderSingleImport()}
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={() => this.handleAdd()}>
              <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving...' : 'Save' }
            </button>
            <button className="btn btn-sm btn-danger" onClick={e => this.clearData(e)}>
              <i className="fa fa-ban"> </i> Clear
            </button>
          </div>
        </div>
        <UploadVideoModal
          open={openVideoModal}
          list={current.listVideos || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadVideoModal>
        <UploadImageModal
          open={openImageModal}
          list={current.listImages || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadImageModal>
        <UploadDocumentModal
          open={openDocumentModal}
          list={current.documents || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadDocumentModal>
      </div>
    );
  }
}

export default ImportProjects;



// WEBPACK FOOTER //
// ./src/views/Projects/Import.js